/**
 * Browser SessionStorage root keys
 * @type {Readonly<{CATALOG: string, RESERVED: string, STORED_VALUE: string}>}
 */
export const StorageKey = Object.freeze({
  RESERVED: 'rewardLink',
  STORED_VALUE: 'storedValue',
  CATALOG: 'catalog',
  CART: 'cart'
})
